import { Fade, Tooltip } from '@mui/material'
import classNames from 'classnames'
import type { Definition } from '../../../types'

interface ModalChipRowProps {
  title: string
  labels: string[]
  wrap?: boolean
  definitions: Definition[]
}

const ModalChipRow = ({
  labels,
  title,
  wrap = false,
  definitions,
}: ModalChipRowProps) => {
  return (
    <div className="flex items-start gap-6">
      <p
        className={classNames(
          'uppercase text-[12px] font-decimal min-w-[90px] max-w-[90px]',
          wrap ? '' : 'whitespace-nowrap'
        )}
      >
        {title}
      </p>
      {labels.length > 0 && (
        <div className="flex gap-1 overflow-x-scroll whitespace-nowrap sm:flex-wrap sm:overflow-x-auto sm:whitespace-normal">
          {labels.map((label) => {
            const tooltipTitle =
              definitions.find((d) => d.display_label === label)?.definition ||
              ' '
            return (
              <Tooltip
                title={tooltipTitle}
                placement="top-end"
                key={`modal-chip-for-${label}`}
                disableInteractive
                enterDelay={0}
                leaveDelay={0}
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 0 }}
              >
                <div className="w-fit text-[12px] border-[1px] border-black p-1 text-black font-decimal cursor-default">
                  {label}
                </div>
              </Tooltip>
            )
          })}
        </div>
      )}
    </div>
  )
}
export default ModalChipRow
